import React, { useMemo } from "react"
import { Button, HStack } from "@chakra-ui/react"
import Icon from "../Icon/Icon"
import ProductSizeFitDrawer from "./ProductSizeFitDrawer"
import { useStorage } from "@hooks/useCore"

const ProductLinks = ({ product, handleOptions }: any) => {
  const [drawerType, setDrawerType] = React.useState("")
  const { getStorage } = useStorage()
  const fitSize = useMemo(() => getStorage("fit-assistant-size"), [getStorage])

  return (
    <>
      <HStack spacing={2}>
        <Button variant="text" textDecor="underline" gap={"4px"} onClick={() => setDrawerType("size-guide")}>
          <Icon name="sizeGuide" size="24px" color={"#7B7670"} />
          Size Guide
        </Button>
        <Button variant="text" textDecor="underline" gap={"4px"} onClick={() => setDrawerType("fit-assistant")}>
          <Icon name="fitAssistant" size="24px" color={"#7B7670"} />
          Fit Assistant{fitSize ? `: ${fitSize}` : null}
        </Button>
      </HStack>
      <ProductSizeFitDrawer
        isOpen={!!drawerType}
        drawerType={drawerType}
        handleDrawerType={setDrawerType}
        onClose={() => setDrawerType("")}
        tags={product?.tags}
        handleOptions={handleOptions}
        product={product}
      />
    </>
  )
}

export default React.memo(ProductLinks)
